var Menu;
(function (Menu) {
    class LeftMenu {
        static toggle() {
            Menu.LeftMenu.initializeHoverFlyouts();
            let body = document.getElementsByTagName('body')[0];
            if (body.hasAttribute('data-leftbar-compact-mode')) {
                body.removeAttribute('data-leftbar-compact-mode');
                body.classList.remove('sidebar-enable');
                Menu.LeftMenu.resetHoverFlyouts();
            }
            else {
                body.setAttribute('data-leftbar-compact-mode', 'condensed');
                body.classList.add('sidebar-enable');
            }
        }
        static hideHover() {
            Menu.LeftMenu.initializeHoverFlyouts();
            let body = document.getElementsByTagName('body')[0];
            if (!body.hasAttribute('data-leftbar-compact-mode')) {
                return;
            }
            body.classList.add('side-nav-hide-hover');
            Menu.LeftMenu.resetHoverFlyouts();
            Menu.LeftMenu.showHover(body);
        }
        static showHover(element) {
            setTimeout(() => { element.classList.remove('side-nav-hide-hover'); }, 150);
        }
        static initializeHoverFlyouts() {
            if (Menu.LeftMenu.hoverFlyoutsInitialized) {
                return;
            }
            Menu.LeftMenu.hoverFlyoutsInitialized = true;
            document.addEventListener('mouseover', (event) => {
                if (!Menu.LeftMenu.isCondensedMode()) {
                    return;
                }
                let item = Menu.LeftMenu.getSideNavItem(event.target);
                if (!item || Menu.LeftMenu.containsNode(item, event.relatedTarget)) {
                    return;
                }
                Menu.LeftMenu.resetHoverFlyouts(item);
                Menu.LeftMenu.positionFlyout(item);
            });
            document.addEventListener('mouseout', (event) => {
                let item = Menu.LeftMenu.getSideNavItem(event.target);
                if (!item || Menu.LeftMenu.containsNode(item, event.relatedTarget)) {
                    return;
                }
                Menu.LeftMenu.resetHoverFlyouts(item);
            });
            window.addEventListener('resize', () => Menu.LeftMenu.resetHoverFlyouts());
        }
        static positionFlyout(item) {
            let flyout = Menu.LeftMenu.getDirectFlyout(item);
            if (!flyout) {
                return;
            }
            Menu.LeftMenu.resetFlyout(flyout);
            requestAnimationFrame(() => {
                if (!Menu.LeftMenu.isCondensedMode() || !item.matches(':hover')) {
                    return;
                }
                Menu.LeftMenu.fitFlyoutInViewport(item, flyout);
            });
        }
        static fitFlyoutInViewport(item, flyout) {
            let padding = Menu.LeftMenu.flyoutViewportPadding;
            let maxHeight = Math.max(120, window.innerHeight - (padding * 2));
            let rect = flyout.getBoundingClientRect();
            if (rect.height > maxHeight) {
                flyout.style.maxHeight = `${maxHeight}px`;
                flyout.style.overflowY = 'auto';
                flyout.style.overflowX = 'hidden';
                rect = flyout.getBoundingClientRect();
            }
            let shift = 0;
            if (rect.bottom > window.innerHeight - padding) {
                shift = window.innerHeight - padding - rect.bottom;
            }
            if (rect.top + shift < padding) {
                shift += padding - (rect.top + shift);
            }
            if (shift !== 0) {
                let itemRect = item.getBoundingClientRect();
                let currentTop = rect.top - itemRect.top;
                flyout.style.top = `${Math.round(currentTop + shift)}px`;
            }
            flyout.classList.add('side-nav-flyout-adjusted');
        }
        static resetHoverFlyouts(container) {
            document.querySelectorAll('.side-nav-flyout-adjusted').forEach((flyout) => {
                if (container && !container.contains(flyout)) {
                    return;
                }
                Menu.LeftMenu.resetFlyout(flyout);
            });
        }
        static resetFlyout(flyout) {
            flyout.style.top = '';
            flyout.style.maxHeight = '';
            flyout.style.overflowX = '';
            flyout.style.overflowY = '';
            flyout.classList.remove('side-nav-flyout-adjusted');
        }
        static getDirectFlyout(item) {
            return item.querySelector(':scope > ul');
        }
        static getSideNavItem(target) {
            if (!(target instanceof HTMLElement)) {
                return null;
            }
            return target.closest('.side-nav-item');
        }
        static containsNode(element, target) {
            return target instanceof Node && element.contains(target);
        }
        static isCondensedMode() {
            let body = document.getElementsByTagName('body')[0];
            return (body === null || body === void 0 ? void 0 : body.getAttribute('data-leftbar-compact-mode')) === 'condensed';
        }
    }
    LeftMenu.hoverFlyoutsInitialized = false;
    LeftMenu.flyoutViewportPadding = 12;
    Menu.LeftMenu = LeftMenu;
})(Menu || (Menu = {}));
